import React from "react";
import { Link } from "react-router-dom";
import FormWizard from "react-form-wizard-component";
import 'react-form-wizard-component/dist/style.css';
class ApplicantDetails extends React.Component {
    render() {
        return (
          <div>

                <div id="circular-menu" className="circular-menu">

                    <a className="floating-btn" >
                        <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                        <i aria-hidden="true" className="fa fa-times"></i>
                    </a>

                    <div className="items-wrapper">
                        <div className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </div>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </a>
                        <Link to="" className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </Link>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        </a>
                    </div>

                </div>
                {/* <!-- row --> */}
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-xl-8">
                            <div className="row card-radius">

                                <div className="col-xl-12">

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="block-header">
                                                {/* <!--Center--> */}
                                                <div className="jobdetail">
                                                    <div className="des">
                                                        <p>Available to join immediately</p>
                                                        <h4 className="block-heading">Samantha Watson</h4>
                                                        <p className="block-text">Applicant : 54254</p>
                                                        <ul className="socialmediaul">
                                                            <li><img src="images/org-img/recruitment/youtube.svg"/></li>
                                                            <li><img src="images/org-img/recruitment/facebook.svg"/></li>
                                                            <li><img src="images/org-img/recruitment/linkidin.svg"/></li>
                                                            <li><img src="images/org-img/recruitment/insta.svg"/></li>
                                                        </ul>
                                                        </div>
                                                    <div className="recruitment-data">
                                                        <a className="h-avatar"><span>
                                                        0.2/5.7 </span>Experience (in Yrs)</a>
                                                        <a className="h-avatar">
                                                            <span>4.2L</span>
                                                            Current CTC</a>
                                                        <a className="h-avatar"><span>5.75L
                                                        </span>Expected CTC</a>
                                                    </div>
                                                    <a className="add-more" href="/RecruitmentDashboard"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
 16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></a>
                                                </div>

                                                {/* <!--Right--> */}

                                            </div>
                                        </div>

                                    </div>
                                </div>


                            </div>
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body ">
                                        <div className="more-jobdetail">
                                            <strong className='' style={{"position":"relative"}}>Contact Number<p className="fw-100">9876543210, 9876543210</p><a className="add-more" href="">
                                            <img src="images/org-img/recruitment/whatsapp.svg" className="w-24"/></a></strong>
                                            
                                            <strong className='' style={{"position":"relative"}}>Email ID<p className="fw-100">samanthawatson@gmail.com</p><a className="add-more" href="">
                                            <img src="images/org-img/recruitment/mail.svg" className="w-24"/></a></strong>
                                            
                                            <strong className='' style={{"position":"relative"}}>Current Company Name <p className="fw-100">Adaan Solutions Pvt. Ltd.</p><a className="add-more" href="">
                                            <img src="images/icon2.png" className="w-24"/></a> </strong>
                                            {/* <strong className='' style={{"position":"relative"}}>Note<p className="fw-100">
                                                <textarea className="form-control" rows="5" col="1"></textarea>
                                                </p></strong>                                                                                      */}
                                            <div className="loadresume mb-4">
                                                <div className="inner">
                                            <img src="images/org-img/recruitment/load.svg"/>
                                            <span>Download Resume</span></div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <button className="applybtn w-auto float-right"><img src="images/org-img/recruitment/apply1.svg"/>Shortlist Applicant</button>
                                            <button className="applybtn w-auto float-right"><img src="images/org-img/recruitment/apply2.svg"/>Send Request for Resume Update</button>
                                            <button className="applybtn w-auto float-right"><img src="images/org-img/recruitment/apply3.svg"/>Schedule an Interview</button>
                                            </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-xl-4">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="shortlisted">
                                                <strong className='upcome'>Recent Activity</strong>
                                                <div className="tab-content">
                                                    <div>
                                                        <div className="interviewee accordion">
                                                            <div className="boxs">
                                                                <div className="position-relatives">
                                                                    <div className="form-head stuck-headers mb-4 mt-2">
                                                                        <div className="form-head stuck-header">
                                                                            <div className="pt-3">
                                                                                {/* <!-- Timeline item --> */}
                                                                                <div className="timeline-item">
                                                                                    <div className="timeline-icon is-squared">
                                                                                        <img className="avatar" src="images/avatar/2.jpg" />
                                                                                    </div>
                                                                                    <div className="timeline-content">
                                                                                        <h5>Shortlisted 08 Oct 2023 for SEO</h5>
                                                                                        <span>06 Oct 2023</span>

                                                                                    </div>
                                                                                </div>
                                                                                {/* <!-- Timeline item --> */}
                                                                                <div className="timeline-item">
                                                                                    <div className="timeline-icon is-squared">
                                                                                        <img className="avatar" src="images/avatar/3.jpg" />
                                                                                    </div>
                                                                                    <div className="timeline-content">
                                                                                        <h5>Pragya Tiwari (HR)</h5>
                                                                                        <span>05 Oct 2023</span>
                                                                                        <p>Sed ut perspiciatis unde omnis iste natus error sit
                                                                                            voluptatem accusantium doloremque.</p>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <!-- Timeline item --> */}

                                                                                {/* <!-- Timeline item --> */}
                                                                                <div className="timeline-item">
                                                                                    <div className="timeline-icon is-squared">
                                                                                        <img className="avatar" src="images/avatar/3.jpg" />
                                                                                    </div>
                                                                                    <div className="timeline-content">
                                                                                        <h5>Alisha Goyal (Product Manager)</h5>
                                                                                        <span>04 Oct 2023</span>
                                                                                        <p>Sed ut perspiciatis unde omnis iste natus error sit
                                                                                            voluptatem accusantium doloremque.</p>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <!-- Timeline item --> */}

                                                                                {/* <!-- Timeline item --> */}
                                                                                <div className="timeline-item">
                                                                                    <div className="timeline-icon is-squared">
                                                                                        <img className="avatar" src="images/avatar/3.jpg" />
                                                                                    </div>
                                                                                    <div className="timeline-content">
                                                                                        <h5>Arun Mishra (CEO)</h5>
                                                                                        <span>03 Oct 2023</span>
                                                                                        <p>Sed ut perspiciatis unde omnis iste natus error sit
                                                                                            voluptatem accusantium doloremque.</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>                                                       
                                                    </div>
                                                </div>
                                            </div>                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal fade" id="contact-manager">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>

                            </div>
                            <div className="modal-body text-center">
                                <form>
                                    <div className="form-group text-left">
                                        <label>Repoting Manager</label>
                                        <select className="default-select form-control wide mb-3">
                                            <option selected disabled>Select reporting manager</option>
                                            <option>Arun Mishra</option>
                                            <option>Pragya Tiwari</option>
                                            <option>Alisha Goyal</option>
                                        </select></div>
                                    <div className="form-group text-left">
                                        <label className="mt-3">Reason</label>
                                        <textarea rows="4" cols="1" className="form-control"></textarea></div>

                                </form>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                                <button type="button" className="btn btn-primary">Accept</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }}
export default ApplicantDetails